import React from 'react'
import { Box, HStack } from "@chakra-ui/react";
import LeftSidebar from "../LeftSideBarLayout/LeftSideBar";
import AdsList from "../adsData/adsList";
import HeaderBar from "../Header/HeaderBar";
import Footer from '../footer';

const Adsinfo = () => {
  return (
    <>
      <Box backgroundColor='#F0F4F9' height={"100%"}>
        <HStack pl='20px' pr={"6px"} w={"100%"} spacing={0} alignItems='flex-start'>
          <LeftSidebar />
          <Box as='main' minW={0} flex={1} ml={"6px"}>
            <HeaderBar />
            <AdsList />
            <Footer />
          </Box>
        </HStack>
      </Box>
    </>
  )
}

export default Adsinfo;